module.exports = "/_next/static/images/7921ecd3dd9eef7795845871548a9b74-credit-card-autonomy@0.75x.png.webp";